import { useQuery } from '@tanstack/react-query';
import { metricsService } from '../services/metrics.service';
import type { MetricsFilters } from '../types/metrics.types';

export function useMetricsSummary(filters?: MetricsFilters) {
  return useQuery({
    queryKey: ['metricsSummary', filters],
    queryFn: () => metricsService.getMetricsSummary(filters),
  });
}

export function useAggregatedMetrics(filters?: MetricsFilters) {
  const { data, ...rest } = useMetricsSummary(filters);

  const aggregated = data?.productMetrics
    ? metricsService.aggregateProductMetrics(data.productMetrics)
    : null;

  return {
    ...rest,
    data: aggregated,
    rawData: data,
  };
}
